// extracted by mini-css-extract-plugin
module.exports = {"description":"style-module_description__iUm7XR0o6gQUzxb2c89CF"};